import script from "./OrdersView.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrdersView.vue?vue&type=script&setup=true&lang=ts"

import "./OrdersView.vue?vue&type=style&index=0&id=dadc3e98&lang=scss"

const __exports__ = script;

export default __exports__